/**
 * User level feature flags that can be toggled in the @see HomeFeaturesPage.
 *
 * @note @see DesignRootSettings.features for the @see Design level features.
 */
export enum UserFeatureFlag {
  /** Banner Message node feature */
  banner = 'banner',
  /** D1 Import feature */
  d1import = 'd1import',
  /** Inventory feature */
  inventory = 'inventory',
  /** Rich Text node feature */
  richText = 'richTextNode',
  /** Wizard Configuration feature */
  wizardConfig = 'wizardConfig'
}
